import { compose } from 'redux'
import { connect } from 'react-redux'

import { selectors as UISelectors } from 'data/ui'
import {
  getOrganizationId,
  getOrganization,
} from 'data/organizations/selectors'
import { updateUserPreferences } from 'data/userPreferences/actions'
import { getChannelsList } from 'data/channels/selectors'
import { providesCreateChannelMutation } from 'components/Channels/dataSync'
import { providesChannelMutations } from 'components/CloneChannel/dataSync'
import { isOwnerOnboardingActive } from 'screens/OnboardingPopover/utils'
import { CHANNEL_TEMPLATES } from './utils'

export default compose(
  providesCreateChannelMutation,
  providesChannelMutations,
  connect(
    state => {
      const organizationId = getOrganizationId(state)
      const organization = getOrganization(state, organizationId)
      return {
        isOwnerOnboardingActive: isOwnerOnboardingActive(state),
        userAssistDisplay: getChannelsList(state).size <= 5,
        isFree: organization.product === 'free',
        channelTemplates: CHANNEL_TEMPLATES,
        currentUserId: UISelectors.getActiveUserId(state),
      }
    },
    { updateUserPreferences }
  )
)
